import React from 'react';
import { showMessage } from 'js/modules/message/actions/MessageActions';
import { BOARD_MESSAGE_CONSTANT } from 'js/modules/message/constants/MessageConstants';
import { getI18NMessage, getI18NMessageString } from 'I18N/I18NHelper';
import CustomScrollbar from 'js/common/components/CustomScrollbar';
import { SketchPicker } from 'react-color';
import { TextField, MenuItem, Popover, Switch, FormControlLabel } from '@mui/material';
import { setFormDirtyFlag, changeIcCardType, changeIcDes, changeIcPos, emptyICConfig,
	changeTriggerFontColor, changeTriggerBgColor, changeTriggerText, saveIssueController,
	resetIssueConfig, setCustomFieldSelection, reOrderCustomField, getCustomFields,
	changeIcAllowedEmails } from '../actions/IssueConfigActions';
import { changeHomePage, changeIssueCollectorStatus, deleteIC } from 'js/app/actions/AppActions';
import { GLOBAL_CONSTANTS } from 'js/common/constants/GlobalConstants';
import IssuePreviewContainer from 'js/modules/preview/components/IssuePreviewContainer';
import EmbedCodeContainer from './EmbedCodeContainer';
import AppHelper from 'js/app/AppHelper';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Button from '@mui/material/Button';
import AppUtil from 'js/utils/AppUtil';

class IssueConfigView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			anchorEl: undefined,
			cpColor: undefined,
			isCpDirty: false,
			colorPickerFor: undefined,
			activeTab: "tab1",
			errorLabelList: [],
			fieldSearchCriteria: undefined
		};

		this.onFormDataChange = this.onFormDataChange.bind(this);
		this.applyRGBOnCP = this.applyRGBOnCP.bind(this);
	}

	componentDidMount() {
		this.props.loadIssueConfig( this.props.issueConfig && this.props.issueConfig.config ?
			this.props.issueConfig.config.customFields : undefined, 
			this.props.store.getState().appData.appData.homePage === GLOBAL_CONSTANTS.EDIT_ISSUE_COLLECTOR,
			this.props.issueConfig && this.props.issueConfig.config ? this.props.issueConfig.config.id : undefined,
			this.props.issueConfig && this.props.issueConfig.config && this.props.issueConfig.config.cardtype);
	}

	changePreviewTab (newValue) {
		this.setState({
			activeTab: newValue
		})
	}

	/* istanbul ignore next */
	scrollReachedToForm (el) {
		return el.getBoundingClientRect().top <= 0;
	}

	handleScroll() {
		const wrappedElement = document.getElementById('ic_form');

  		if ( this.scrollReachedToForm(wrappedElement) ) {
    		this.setState({activeTab:"tab2"})
  		} else {
			this.setState({activeTab:"tab1"})
		}
	}
	
	render() {
		if ( Object.keys(this.props).length === 0 || !this.props.issueConfig ) {
			return false;
		}
		
		const issueConfig = this.props.issueConfig.config; 
		const triggerBtnStyle = {
			backgroundColor: this.getRGBAText( this.state.colorPickerFor === 'triggerbg' && this.state.cpColor ? this.state.cpColor : issueConfig.triggerbgcolor ),
			color: this.getRGBAText( this.state.colorPickerFor === 'triggerfont' && this.state.cpColor ? this.state.cpColor : issueConfig.triggerfontcolor )
		};

		const headerPrefix = issueConfig.id ? getI18NMessage('edit') : getI18NMessage('provide');
		const isMoreInstructionEnabled = this.props.issueConfig.toggleMoreInstruction;

		return (
			<div className={`ic_config_cnt full_height full_width ${ isMoreInstructionEnabled ? 'more_inst_ic_config' : '' }`} key={`ic_config_form_${ this.props.issueConfig.reloadForm ? 'Y' : 'N' }`}>
                <div className='ic_header full_width icHeaderBg bold'>{ headerPrefix } { getI18NMessage('ic_config_header') }</div>
				<div className='ic_config_form_cnt full_width'>
					<div className='left_panel'>
						<CustomScrollbar onScroll={ this.handleScroll.bind(this) } style={{ height: 'calc(100% - 48px)', width: '100%' }} className='ic_config_form_scroll_cnt'>
							{
								this.getICForm()
							}
						</CustomScrollbar>
						<div className='ic_config_footer full_width full_height'>
							<div className='float_right full_height'>
								{
									issueConfig.id && this.getFooterTernaryButtons(issueConfig)
								}
								<Button color="primary" onClick={ this.loadListing.bind(this) }>{ getI18NMessage("return") }</Button>
								{
									issueConfig.id &&
										<Button color="primary" onClick={ this.resetForm.bind(this) }
											disabled={ !this.props.issueConfig.isDirty }>{ getI18NMessage("reset") }</Button>
								}
								<Button variant="contained" color="primary" 
                                            onClick={ this.saveIssueCollector.bind(this) }
                                            disabled={ !this.props.issueConfig.isDirty }>{ getI18NMessage("save") }</Button>
							</div>
						</div>
					</div>
					<div className='right_panel'>
					<div className="preview_section">
						<div className="preview_header">
							<span className= {`preview_tab tab1 ${this.state.activeTab === "tab1" ? "active" : ""}`} onClick = {() => {this.changePreviewTab("tab1")}}>{getI18NMessage("trigger_preview")}</span>
							<span className= {`preview_tab tab2 ${this.state.activeTab === "tab2" ? "active" : ""} ${issueConfig.id ? "" : "right_border_radius"}`} onClick = {() => {this.changePreviewTab("tab2")}}>{getI18NMessage("template_preview")}</span>
							{
								issueConfig.id &&
									<span className= {`preview_tab tab3 ${this.state.activeTab === "tab3" ? "active" : ""}`} onClick = {() => {this.changePreviewTab("tab3")}}>{getI18NMessage("embedcode")}</span>
							}
							<div className="preview_body">
								{
									this.state.activeTab === "tab1" && 
										<div className={`trigger_preview ${ this.state.activeTab }`}>
											<img className='full_width full_height' 
												src={ AppUtil.processURLForAppContextPath('images/digiteweb.png') } 
												alt='digiteweb'></img>
											<span className={`trigger_btn ${ issueConfig.position }`} style={ triggerBtnStyle }>{ issueConfig.triggertext }</span>
										</div>
								}
								{
									this.state.activeTab === "tab2" && 
										<div className="preview ic_form_preview"> 
											<IssuePreviewContainer issueConfig={ issueConfig } isDisabled={true} />
										</div>
								}
								{
									this.state.activeTab === "tab3" && 
										<EmbedCodeContainer editmode={ issueConfig.id } store={ this.props.store } />
								}
							</div>
						</div>
					</div>
				</div>
            </div>
		</div>
		);
	}

	getFooterTernaryButtons(issueConfig) {
		return (
			<React.Fragment>
				<Button color="secondary" onClick={ this.onDeleteICClick.bind(this) }>{ getI18NMessage("delete") }</Button>
				<Button color="secondary" onClick={ this.changeStatus.bind(this) }>{ issueConfig.status === GLOBAL_CONSTANTS.ENABLED ? getI18NMessage('disable') :
					 getI18NMessage('enable') }</Button>
			</React.Fragment>
		)
	}

	/* istanbul ignore next */
	//this function changing the state in store . No need to automate here
	changeStatus() {
		const issueConfig = this.props.issueConfig.config; 

		let status;

		if ( issueConfig.status === GLOBAL_CONSTANTS.ENABLED ) {
			status = GLOBAL_CONSTANTS.DIENABLED
		} else {
			status = GLOBAL_CONSTANTS.ENABLED;
		}

		this.props.store.dispatch( changeIssueCollectorStatus(issueConfig.id, status, true) );
	}

	//Below functions dont have any business logic. They just changingg the state of store, hence ignore in jest automation
	/* istanbul ignore next */
	deleteIC(id) {
		this.props.store.dispatch( deleteIC(id) );
		this.cancelICConfig();
	}

	/* istanbul ignore next */
	onDeleteICClick() {
		const issueConfig = this.props.issueConfig.config; 
		const that = this;

		this.props.store.dispatch( showMessage({
			type: BOARD_MESSAGE_CONSTANT.TYPE_CONFIRMATION,
			message: getI18NMessage( 'delete_confirmation' ),
			onConfirmFn: () => {
				that.deleteIC(issueConfig.id);
			}
		}) );
	}

	/* istanbul ignore next */
	loadListing() {
		if ( this.props.issueConfig.isDirty ) {
			this.props.store.dispatch( showMessage({
                type: BOARD_MESSAGE_CONSTANT.TYPE_CONFIRMATION,
				message: getI18NMessage( 'unsavedDataLossWarning' ),
				onConfirmFn: this.cancelICConfig.bind(this)
            }) );

		} else {
			this.cancelICConfig();
		}
	}

	/* istanbul ignore next */
	resetForm() {
		if ( this.props.issueConfig.isDirty ) {
			this.props.store.dispatch( resetIssueConfig(this.props.issueConfig.config.id, this.props.issueConfig.config.customFields) );
		}
	}

	/* istanbul ignore next */
	cancelICConfig() {
		this.props.store.dispatch( emptyICConfig(undefined) );
		this.props.store.dispatch( changeHomePage(GLOBAL_CONSTANTS.ISSUE_LISTING) );
		this.props.store.dispatch( setFormDirtyFlag(false) );
	}

	/* istanbul ignore next */
	onFormDataChange() {
		this.props.store.dispatch( setFormDirtyFlag(true) );
	}

	/* istanbul ignore next */
	onCardTypeChange( event ) {
		this.props.store.dispatch( changeIcCardType(event.target.value) );
		this.props.store.dispatch( getCustomFields(event.target.value) );
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	onDescChange( event ) {
		this.props.store.dispatch( changeIcDes(event.target.value) );
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	onAllowedEmailChange ( event ) {
		this.props.store.dispatch( changeIcAllowedEmails(event.target.value) );
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	onPosChange( event ) {
		this.props.store.dispatch( changeIcPos(event.target.value) );
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	onTriggerTextChange( event ) {
		this.props.store.dispatch( changeTriggerText(event.target.value) );
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	onScreenTitleChange( event ) {
		this.props.changeScreenTitle(event.target.value);
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	onIntrodcuctionTextChange( event ) {
		this.props.changeIntroductionText(event.target.value);
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	onIssueTitleChange( event ) {
		this.props.changeIssueTitle(event.target.value);
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	onDescriptionTitleChange( event ) {
		this.props.changeDescriptionTitle(event.target.value);
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	onAttachmentSwitchChange ( event ) {
		this.props.isAttachmentAvailable(event.target.checked);
		this.onFormDataChange();
	}

	/* istanbul ignore next */
	saveCpColor() {
		if ( this.state.colorPickerFor === 'triggerfont' )
			this.props.store.dispatch( changeTriggerFontColor(this.state.cpColor) );
		else
			this.props.store.dispatch( changeTriggerBgColor(this.state.cpColor) );

		this.closeColorPicker();
		this.onFormDataChange();
	}

	getPositionList() {
		const selectedPos = this.props.issueConfig.config.position;

		let posList = [{
			value: 'top',
			text: 'Top'
		}, {
			value: 'bottom',
			text: 'Bottom'
		}, {
			value: 'left',
			text: 'Left'
		}, {
			value: 'right',
			text: 'Right'
		}, {
			value: 'topleft',
			text: 'Top Left'
		}, {
			value: 'topright',
			text: 'Top Right'
		}, {
			value: 'bottomleft',
			text: 'Bottom Left'
		}, {
			value: 'bottomright',
			text: 'Bottom Right'
		}, {
			value: 'vtopleft',
			text: 'Vertical Top Left'
		}, {
			value: 'vtopright',
			text: 'Vertical Top Right'
		}, {
			value: 'vbottomleft',
			text: 'Vertical Bottom Left'
		}, {
			value: 'vbottomright',
			text: 'Vertical Bottom Right'
		}]

		if ( selectedPos )
			posList = posList.map( pos => ({
				...pos,
				selected: pos.value === selectedPos
			}) )
		else
			posList[0].selected = true;

		return posList;
	}

	openColorPicker( event ) {
		this.setState({
			anchorEl: event.target,
			colorPickerFor: event.target.getAttribute('colorpickerfor')
		});
	}

	closeColorPicker() {
		this.setState({
			anchorEl: undefined,
			cpColor: undefined,
			isCpDirty: false
		});
	}

	handleColorChange( color ) {
		this.setState({
			cpColor: color.rgb,
			isCpDirty: true
		});
	}

	applyRGBOnCP(event) {
		const bg = event.target.style.backgroundColor;
		const bgStr = bg.slice(4, bg.length - 1).split(',');

		this.setState({
			cpColor: {
				r: bgStr[0].trim(),
				g: bgStr[1].trim(),
				b: bgStr[2].trim(),
				a: bgStr.length > 3 ? bgStr[3] : 1
			}
		});
	}

	getRGBAText(color) {
		return `rgba(${color.r},${color.g},${color.b},${color.a})`;
	}

	getColorPicker( config, savedColor ) {
		const anchorOrigin = {
			vertical: 'bottom',
			horizontal: 'center'
		};
		const transformOrigin = {
			vertical: 'top',
			horizontal: 'center'
		}

		const newColor = this.state.cpColor || savedColor;
		const presetColors = ['#ff9966', '#ff66cc', '#ffff99', '#99ff66', '#66ffff', '#66ccff', '#cc99ff', '#3399ff', 
			'#ccff99', '#ffccff', '#EB144C', '#fccb00', '#9c27b0', '#607d8b', '#8b7d60', '#000000', '#ffffff', '#9b9b9b'];

		return (
			<Popover className='color_picker' open={ this.state.anchorEl ? true : false } anchorEl={ this.state.anchorEl } anchorOrigin={ anchorOrigin } transformOrigin={ transformOrigin }>
				<div className='color_picker_cnt'>
					<div className='cp_header bold'>{ getI18NMessage('colorpicker') } <span className='cp_close icon-close float_right cur_pointer' onClick={ this.closeColorPicker.bind(this) }></span></div>
					<SketchPicker width={ 230 } color={ newColor } presetColors={ presetColors } onChange={ this.handleColorChange.bind(this) }/>
					<div className='cp_right_panel float_left'>
						<label className='cp_label float_left'>{ getI18NMessage('new') }</label>
						<div className='new_color_preview float_left cur_pointer' style={{
							backgroundColor: this.getRGBAText(newColor)
						}} onClick={ this.applyRGBOnCP }></div>
						<div className='current_color_preview float_left cur_pointer' style={{
							backgroundColor: this.getRGBAText(savedColor)
						}} onClick={ this.applyRGBOnCP }></div>
						<label className='cp_label float_left cur_pointer' onClick={ this.applyRGBOnCP }>{ getI18NMessage('current') }</label>
						<span className={`float_left primaryBtn color_white cp_save ${ this.state.isCpDirty ? 'cur_pointer' : 'disable' }`} onClick={ this.saveCpColor.bind(this) }>{ getI18NMessage('save') }</span>
					</div>
				</div>
			</Popover>
		);
	}

	getICForm() {
		const config = this.props.issueConfig.config;
		let cardTypes = AppHelper.getAppData( 'card_type_list' ) || [];

		cardTypes = cardTypes.sort((a, b) => a.cardTypeName.localeCompare(b.cardTypeName)).filter( cardType => cardType.isSelected );

		const cardTypeValue = cardTypes.length > 0 ? config.cardtype || cardTypes[0].cardType : undefined;
		const descInputProps = {
			maxLength: 600
		}
		const remainingDescCharacter = config.description ? 600 - config.description.length : 600;
		const positionList = this.getPositionList();
		const selectedPos = config.position || positionList.filter( pos => pos.selected )[0].value;
		const savedFontColor = config.triggerfontcolor || {
			r: 0,
			g: 0,
			b: 0,
			a: 1
		};
		const savedBgColor = config.triggerbgcolor || {
			r: 255,
			g: 153,
			b: 102,
			a: 1
		};

		const customFields = config.customFields || [];

		customFields.sort(function(a, b) {
			return a.order - b.order;
		});

		let nonSelectedFields = customFields.filter( field => !field.selectedType );

		if ( this.state.fieldSearchCriteria && this.state.fieldSearchCriteria !== '' ) {
			nonSelectedFields = nonSelectedFields.filter(field => field.fieldLabel.toUpperCase().indexOf(this.state.fieldSearchCriteria.toUpperCase()) !== -1);
		}

		const listHeight = 'calc(100% - 48px)';
		
		return (
			<div className='ic_config_form full_width full_height'>
				<span className='float_left full_width ic_from_seg_header bold'>1. { getI18NMessage('ic_detail') }</span>
				<TextField defaultValue={ config.name } required fullWidth error={ this.state.errorLabelList.indexOf('ic_name') !== -1 } id="ic_name" label="Name" variant="outlined" autoFocus={ true } onChange={ this.onFormDataChange }/>
				<TextField defaultValue={ config.description } id="ic_desc" label="Description" multiline fullWidth rows="4" variant="outlined" inputProps={ descInputProps } onChange={ this.onDescChange.bind(this) } />
				<span className='float_right fullwidth descTextCount'>{ remainingDescCharacter } { getI18NMessage('charleft') }</span>
				<TextField error={ this.state.errorLabelList.indexOf('ic_card_type') !== -1 } 
					id="ic_card_type" select required fullWidth label="Card Type" value={ cardTypeValue } onChange={ this.onCardTypeChange.bind(this) } variant="outlined">
					{
						cardTypes.map(option => (
							<MenuItem key={ option.id } value={ option.cardType }>{ option.cardTypeName }</MenuItem>
						))
					}
        		</TextField>
				<TextField defaultValue={ config.allowedEmailIds } id="ic_allowedEmail" label="Allowed Email Addresses" 
				multiline fullWidth rows="2" inputProps={{ maxLength: 2000}} variant="outlined" onChange={ this.onAllowedEmailChange.bind(this) } />
				<span className='float_right fullwidth descTextCount'>{ getI18NMessage('allowedEmailHelp') }</span>
				
				<span className='float_left full_width ic_from_seg_header bold'>2. { getI18NMessage('trigger') }</span>
				<TextField defaultValue={ config.triggertext } error={ this.state.errorLabelList.indexOf('ic_trigger_text') !== -1 } 
					required fullWidth id="ic_trigger_text" label="Trigger Text" variant="outlined" onChange={ this.onTriggerTextChange.bind(this) }/>
				<TextField id="ic_trigger_pos" select required fullWidth label="Position" value={ selectedPos } onChange={ this.onPosChange.bind(this) } variant="outlined">
					{
						positionList.map(option => (
							<MenuItem key={ option.value } value={ option.value }>{ option.text }</MenuItem>
						))
					}
        		</TextField>
				<div className='full_width color_cnt_div font_cnt_div'>
					<label className='ic_config_label float_left'>{ getI18NMessage('fontcolor') }</label>
					<span className='ic_color_box float_left cur_pointer' colorpickerfor='triggerfont' style={{
						backgroundColor: this.getRGBAText(savedFontColor)
					}} onClick={ this.openColorPicker.bind(this) }></span>
				</div>
				<div className='full_width color_cnt_div bg_cnt_div'>
					<label className='ic_config_label float_left'>{ getI18NMessage('bgcolor') }</label>
					<span className='ic_color_box float_left cur_pointer' colorpickerfor='triggerbg' style={{
						backgroundColor: this.getRGBAText(savedBgColor)
					}} onClick={ this.openColorPicker.bind(this) }></span>
				</div>
				{
					this.getColorPicker( config, this.state.colorPickerFor === 'triggerbg' ? savedBgColor : savedFontColor )
				}
				<div id="ic_form">
					<span className='float_left full_width ic_from_seg_header bold'>3. { getI18NMessage('ic_collector_form') }</span>
					<TextField defaultValue={ config.screentitle } required fullWidth id="ic_screen_title" 
						label={getI18NMessage("screen_title")} variant="outlined" onChange={ this.onScreenTitleChange.bind(this) }
						error={ this.state.errorLabelList.indexOf('ic_screen_title') !== -1 }/>
					<TextField defaultValue={ config.introductiontext } required id="ic_introduction_text"
						label={getI18NMessage("introduction_text")} multiline fullWidth rows="4" variant="outlined"
						inputProps={ descInputProps } onChange={ this.onIntrodcuctionTextChange.bind(this) }
						error={ this.state.errorLabelList.indexOf('ic_introduction_text') !== -1 }/>
					<TextField defaultValue={ config.issuetitle } fullWidth id="ic_issue_title" label={getI18NMessage("issue_title")} variant="outlined" 
					error={ this.state.errorLabelList.indexOf('ic_issue_title') !== -1 } onChange={ this.onIssueTitleChange.bind(this) } />
					<TextField defaultValue={ config.descriptiontitle } fullWidth id="ic_desc_title" label={getI18NMessage("description_title")} variant="outlined" 
						error={ this.state.errorLabelList.indexOf('ic_desc_title') !== -1 } onChange={ this.onDescriptionTitleChange.bind(this) }/>
					{
						customFields && <React.Fragment>
							<DragDropContext onDragEnd={this.onDragEnd.bind(this)}>
								<div className='customfield_left_panel'>
									<div className='fieldheader bold'>{ getI18NMessage("availablefields") }</div>
									<div className='searchbox'>
										<input type='text' placeholder={ getI18NMessageString("searchfields") } onChange={ this.filterCustomFields.bind(this) }></input>
										<span className='icon-search float_right pos_abs'></span>
									</div>
									<CustomScrollbar style={{ height: 'calc(100% - 100px)', width: 'calc(100% - 6px)' }} className='field_list_scroll_cnt'>
										{
											this.getDroppable('droppable', nonSelectedFields)
										}
									</CustomScrollbar>
								</div>
								<div className='customfield_right_panel'>
									<div className='custom_mandatory_fields'>
										<div className='fieldheader bold'>
											{ getI18NMessage("mandatoryfields") }
											<span className='mandatory_mark bold'>*</span>
										</div>
										<CustomScrollbar style={{ height: listHeight, width: 'calc(100% -8px)' }} className='droppable_scroll_cnt'>
											{
												this.getDroppable('mandatory',
												customFields.filter( field => field.selectedType === 'mandatory' ),
													getI18NMessage("dragdropmsg"), true)
											}
										</CustomScrollbar>
									</div>
									<div className='custom_non_mandatory_fields'>
										<div className='fieldheader bold'>{ getI18NMessage("nonmandatoryfields") }</div>
										<CustomScrollbar style={{ height: listHeight, width: 'calc(100% -8px)' }} className='droppable_scroll_cnt'>
											{
												this.getDroppable('nonmandatory',
													customFields.filter( field => field.selectedType === 'nonmandatory' ),
													getI18NMessage("dragdropmsg"), true)
											}
										</CustomScrollbar>
									</div>
								</div>
							</DragDropContext>
						</React.Fragment>
					}
					<FormControlLabel id = "ic_attachment" onChange= {this.onAttachmentSwitchChange.bind(this)}
						value="Attach"
						control={<Switch
							value="Attach"
							color="primary"
							checked={ config.isattachmentavailable }
						/>}
						label="Attach"
						labelPlacement="start"
					/>
					
				</div>
			</div>
		);
	}

	/* istanbul ignore next */
	onDragEnd(result) {
		const { source, destination, draggableId } = result;
		
		if (!destination) {
            return;
		}
		
		if (source.droppableId !== destination.droppableId) {
			this.props.store.dispatch( setCustomFieldSelection(draggableId, 
				destination.droppableId === 'droppable' ? undefined : destination.droppableId) );
        }
		
		this.props.store.dispatch( reOrderCustomField(draggableId, destination.index, 
			destination.droppableId === 'droppable' ? undefined : destination.droppableId) );

		if ( source.droppableId !== destination.droppableId || destination.droppableId !== 'droppable')
			this.onFormDataChange();
	}

	getDroppable(droppableId, fields, placeholder, showCloseIcon) {
		return (
			<Droppable droppableId={ droppableId }>
				{ provided => (
					<ul ref={ provided.innerRef } className={`list_style_none ${ fields.length === 0 ? 'empty_list bold' : '' }`}>
						{
							fields.map((item, index) => (
								<Draggable key={ item.fieldName } draggableId={ item.fieldName } index={ index }>
									{
										(providedinner, snapshotinner) => (
											<li ref={providedinner.innerRef} {...providedinner.draggableProps} 
												{...providedinner.dragHandleProps} className={`${showCloseIcon ? 'li_with_close' : ''} ${snapshotinner.isDragging ? 'field_dragging' : ''}`}>
												<span className='text' title={ item.fieldLabel }>{ item.fieldLabel }</span>
												{
													showCloseIcon &&
														<span className='icon-close remove_field' onClick={this.removeField.bind(this)} data_id={ item.fieldName }></span>
												}
												{
													item.isMandatory &&
														<span className='mandatory_mark bold'>*</span>
												}
											</li>
										)
									}
								</Draggable>
							))
						}
						{
							fields.length === 0 && placeholder
						}
					</ul>
				)}
			</Droppable>
		)
	}

	/* istanbul ignore next */
	removeField(event) {
		this.props.store.dispatch( setCustomFieldSelection(event.target.getAttribute('data_id'), undefined) );
		this.onFormDataChange();
	}

	filterCustomFields(event) {
		this.setState({
			fieldSearchCriteria: event.target.value
		});
	}

	/* istanbul ignore next */
	saveIssueCollector() {
		if ( this.props.issueConfig.isDirty ) {
			const config = this.validateICForm();

			if ( config ) {
				this.props.store.dispatch( saveIssueController(config, this.props.issueConfig.config.customFields) );
			} else {
				this.props.store.dispatch( showMessage({
					type: BOARD_MESSAGE_CONSTANT.TYPE_WARNING,
					message: getI18NMessage( 'emptyMandatoryError' )
				}) );
			}
		}
	}

	/* istanbul ignore next */
	validateICForm() {
		const cardTypes = AppHelper.getAppData( 'card_type_list' ) || [];
		cardTypes.sort((a, b) => a.cardTypeName.localeCompare(b.cardTypeName));
		
		const userId = AppHelper.getAppData('user_data').id;
		const config = this.props.issueConfig.config;
		const errorLabelList = [];
		const collectorConfig = {
			id: config.id,
			enterpriseid: AppHelper.getParamData('icentid'),
			projectid: AppHelper.getAppData('projectId'),
			name: document.getElementById('ic_name').value.trim(),
			description: document.getElementById('ic_desc').value.trim(),
			cardtype: config.cardtype || cardTypes.filter( cardType => cardType.isSelected )[0].cardType,
			triggertext: document.getElementById('ic_trigger_text').value.trim(),
			position: config.position,
			triggerbgcolor: config.triggerbgcolor,
			triggerfontcolor: config.triggerfontcolor,
			status: config.status || GLOBAL_CONSTANTS.ENABLED,
			createdby: userId,
			updatedby: userId,
			screentitle: config.screentitle,
			introductiontext: config.introductiontext,
			issuetitle: config.issuetitle,
			descriptiontitle: config.descriptiontitle,
			isattachmentavailable: config.isattachmentavailable,
			customFields: config.customFields.filter( field => field.selectedType ),
			allowedEmailIds: config.allowedEmailIds
		}

		if ( config.descriptionControlType ) {
			collectorConfig.descriptionControlType = config.descriptionControlType;
		}

		if ( collectorConfig.name === '' ) {
			errorLabelList.push('ic_name');
		}

		if ( collectorConfig.cardtype === '' ) {
			errorLabelList.push('ic_card_type');
		}

		if ( collectorConfig.triggertext === '' ) {
			errorLabelList.push('ic_trigger_text');
		}

		if ( !collectorConfig.screentitle || collectorConfig.screentitle === '' ) {
			errorLabelList.push('ic_screen_title');
		}

		if ( !collectorConfig.introductiontext || collectorConfig.introductiontext === '' ) {
			errorLabelList.push('ic_introduction_text');
		} 
		
		this.setState({
			errorLabelList
		});

		return errorLabelList.length > 0 ? undefined : collectorConfig;
	}
}

export default IssueConfigView;